import React from 'react';
import PropTypes from 'prop-types';
import CorrectAlertIcon from '@learningblocks/exp-constants/lib/Images/alert_icon_correct.svg';
import IncorrectAlertIcon from '@learningblocks/exp-constants/lib/Images/alert_icon_incorrect.svg';
import {Image} from '@learningblocks/storybook-components';
import {useTranslation} from 'react-i18next';

import './style.scss';

const ITEM_RESULT = {
  YES: 'Yes',
  NO: 'No',
};

export function ListItem(props) {
  const {t} = useTranslation();

  const TRANSLATION_KEY =
    props.text +
    (props.isSuccess ? ITEM_RESULT.YES : ITEM_RESULT.NO) +
    '.string';

  const renderAlertIcon = () =>
    props.isSuccess ? (
      <Image className='mc_warningItem_icon' src={CorrectAlertIcon} />
    ) : (
      <Image className='mc_warningItem_icon' src={IncorrectAlertIcon} />
    );

  return (
    <div className='mc_warningItem'>
      <span className='mc_warningItem_text'>{t(TRANSLATION_KEY)}</span>
      {renderAlertIcon()}
    </div>
  );
}

ListItem.propTypes = {
  /**
   * bool value that specifies if the condition is success or not
   */
  isSuccess: PropTypes.bool,
  /**
   * text that specifies the warning message
   */
  text: PropTypes.string,
};

ListItem.defaultProps = {
  text: '',
};
